export default function Canvas_Circles() {
  return (
    <div>
      <h1>Canvas_Circles Component</h1>
    </div>
  );
}
